import { createFileRoute, Link } from '@tanstack/react-router'
import { HelpLayout } from '@/components/help-center/help-layout'
import { HelpArticleContent } from '@/components/help-center/help-article'

export const Route = createFileRoute('/_public/app/help/privacy-security')({
  component: PrivacySecurityPage,
  head: () => ({
    meta: [
      { title: 'Privacy and Security | MessageDrafts Help' },
      {
        name: 'description',
        content:
          'Learn how MessageDrafts keeps contacts and message drafts on your device and minimizes data storage.',
      },
    ],
  }),
})

function PrivacySecurityPage() {
  return (
    <HelpLayout
      title="Privacy and security"
      description="How MessageDrafts handles your contacts, drafts, and data."
    >
      <HelpArticleContent
        slug="privacy-security"
        title="Overview"
        description="MessageDrafts keeps you in control by opening drafts in your own apps."
        tags={['privacy', 'security', 'data']}
        devices={['windows', 'macos', 'linux', 'iphone', 'ipad', 'android']}
      >
        <section className="space-y-3">
          <h3 className="text-xl font-semibold text-slate-900">What happens on your device</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Contacts are used to build drafts and aren’t sent automatically.</li>
            <li>Messages open as drafts in your SMS or email app.</li>
            <li>You choose exactly when to send.</li>
            <li>
              After the app loads, you can disconnect from the internet and keep
              working.
            </li>
          </ul>
        </section>

        <section className="space-y-3">
          <h3 className="text-xl font-semibold text-slate-900">What we store (and don’t store)</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>We do not store message content after your session.</li>
            <li>Contacts are not saved long-term on our servers.</li>
            <li>We do not use third-party SMS services.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h3 className="text-xl font-semibold text-slate-900">Permissions</h3>
          <p>
            Importing contacts uses your browser’s contact picker or a CSV file you upload. You
            can revoke contact access at any time in your browser or device settings.
          </p>
        </section>

        <section className="space-y-3">
          <h3 className="text-xl font-semibold text-slate-900">Data deletion</h3>
          <p>
            If you sign in, you can delete your data from account settings. For additional
            questions, review the <Link to="/app/help/faq" className="underline">
              FAQ
            </Link>{' '}
            or contact support.
          </p>
        </section>
      </HelpArticleContent>
    </HelpLayout>
  )
}
